import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  containerHorizontal: {
    width: '100%',
    height: 1289,
    display: 'flex',

    [theme.breakpoints.up('lg')]: {
      margin: '0 auto',
      height: 717
    }
  }
}))
